// ============================================================
// localStorage 封装
// 三端靠不同 origin（端口 / 域名）隔离，key 不再加 zm:<app>: 前缀。
// APP_TARGET 仍导出，供请求头 X-App-Target 等使用。
// ============================================================
declare const __APP_TARGET__: "admin" | "manage" | "customer";

/** 本端已知持久化 key；clearAppScope 只清这些，避免误伤其它同源数据 */
const APP_STORAGE_KEYS = ["authorization", "userInfo", "asyncTasks:active", "asyncTasks:waiting"] as const;

function safeParse<T>(raw: string | null, fallback: T | null = null): T | null {
    if (raw == null) return fallback;
    try {
        return JSON.parse(raw) as T;
    } catch {
        return fallback;
    }
}

export const storage = {
    get<T = unknown>(key: string): T | null {
        return safeParse<T>(localStorage.getItem(key));
    },

    set(key: string, value: unknown): void {
        localStorage.setItem(key, JSON.stringify(value));
    },

    remove(key: string): void {
        localStorage.removeItem(key);
    },

    /** 清掉本端业务用到的 key */
    clearAppScope(): void {
        for (const key of APP_STORAGE_KEYS) {
            localStorage.removeItem(key);
        }
    },
};

/** 当前端标识（运行时可读） */
export const APP_TARGET: "admin" | "manage" | "customer" = __APP_TARGET__;
